import React from "react";
import { Typography, Row, Col, Card, Badge } from "antd";
import { 
  BulbOutlined, 
  DesktopOutlined, 
  TeamOutlined 
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const Services = () => {
  const services = [
    {
      icon: <BulbOutlined style={{ fontSize: '48px', color: '#40a9ff' }} />,
      title: "Audit & Diagnostic",
      description: "Analyse complète de vos installations électriques, évaluation des risques et définition des besoins spécifiques pour optimiser votre système de courant faible.",
      number: "1"
    },
    {
      icon: <DesktopOutlined style={{ fontSize: '48px', color: '#40a9ff' }} />,
      title: "Études & Conception",
      description: "Dimensionnement technique, conception de schémas électriques et plans d'exécution optimisés pour garantir la performance et la conformité de vos installations.",
      number: "2"
    },
    {
      icon: <TeamOutlined style={{ fontSize: '48px', color: '#40a9ff' }} />,
      title: "Installation & Maintenance",
      description: "Pose professionnelle, câblage et mise en service par nos équipes certifiées, avec un suivi maintenance pour assurer la pérennité de vos équipements.",
      number: "3"
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff' ,padding: '60px 24px'}}>
  {/* Title Section */}
  <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={1} style={{ 
            fontSize: '48px', 
            fontWeight: 700, 
            color: '#000',
            marginBottom: '20px'
          }}>
            Nos Services
          </Title>
        
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '80px 24px' }}>
        
        {/* Our Services Banner */}


        {/* Services Cards */}
        <Row gutter={[32, 32]}>
          {services.map((service, index) => (
            <Col xs={24} md={8} key={index}>
              <Card 
                hoverable
                style={{ 
                  height: '100%',
                  borderRadius: '16px',
                  border: '1px solid #f0f0f0',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                styles={{ 
                  body: { padding: '40px 30px' } 
                }}
              >
                {/* Number Badge */}
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  background: index === 2 ? '#40a9ff' : '#54ba66',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '16px'
                }}>
                  {service.number}
                </div>

                {/* Icon */}
                <div style={{ 
                  textAlign: 'center', 
                  marginBottom: '30px',
                  marginTop: '10px'
                }}>
                  {service.icon}
                </div>

                {/* Title */}
                <Title level={3} style={{ 
                  color: '#54ba66', 
                  fontSize: '20px',
                  fontWeight: 600,
                  marginBottom: '20px',
                  textAlign: 'center'
                }}>
                  {service.title}
                </Title>

                {/* Description */}
                <Paragraph style={{ 
                  color: '#666',
                  lineHeight: 1.6,
                  textAlign: 'center',
                  margin: 0
                }}>
                  {service.description}
                </Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default Services;
